module.exports = __webpack_public_path__ + "static/img/2.5cfe563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/2.png
// module id = BmDQ
// module chunks = 0